<template>
  <div class="question-container">

    <div class="question">
      <template v-if="activity == ''">
          <div class="activity-header">
            {{ question.activityQuestion }}
          </div>
          <div class="activity">
            <div class="option green" @click="activity = 'yes'"  :class="{'not-selected' : activity != 'yes' }">
              <i class="far fa-thumbs-up"></i>
            </div>
            <div class="option red" @click="activity = 'no'"  :class="{'not-selected' : activity != 'no' }">
              <i class="far fa-thumbs-down"></i>
            </div>
        </div>
      </template>

      <div v-else class="subquestion">
        <sub-question :question="currentSubquestion" @next="nextSubquestion"/>
      </div>
    </div>

    <div v-if="activity" class="undo-activity-selection" @click="back()">
      Zurück
    </div>

  </div>
</template>

<script>
import SubQuestion from '@/components/SubQuestion.vue'
export default {
  name: 'Question',
  props: ['question', 'section'],
  components: {
    SubQuestion,
  },
  data() {
    return {
      relevance: '',
      activity: '',

      subQuestionIndex: 0,

      selectedAnswers: []
    }
  },
  methods: {
    nextSubquestion(answers) {
      this.$store.commit('addAnswer', {
        section: this.section,
        measure: this.question.name,
        relevance: this.relevance,
        active: this.activity,
        question: this.currentSubquestion.question,
        answer: answers,
        score: 0, // FIXME:
      })
      
      if(this.subQuestionIndex < this.subQuestions.length-1) {
        this.subQuestionIndex++
        return
      }

      this.subQuestionIndex = 0
      this.relevance = ''
      this.activity = ''
      this.$emit('next')
    },
    back() {
      console.log(this.subQuestionIndex)
      if (this.subQuestionIndex == 0) {
        this.activity = ''
      } else {
        this.subQuestionIndex--
      }
    }

  },
  computed: {
    subQuestions() {
      return this.activity == 'yes' ? this.question.subquestionsActive : this.question.subquestionsInactive
    },
    currentSubquestion() {
      if(this.subQuestions && this.subQuestions.length > 0)
        return this.subQuestions[this.subQuestionIndex]
      return {}
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.question-container {
}
.question {
  border-radius: $border-radius;
  @include shadow;
  background-color: white;
}

.activity-header {
  padding: 20px;
  font-size: 20px;
  font-weight: 500;
  text-align: left;
  color: $gText;
}

.not-selected {
  color: rgba(0, 0, 0, 0.6);
}

.relevance, .activity {
  display: flex;

  .option {
    flex: 1;
    padding: 30px;
    font-size: 30px;
    cursor: pointer;
  }
}

.undo-activity-selection {
  margin: 30px 0px;
}
</style>
